<template>
<b-dropdown right no-caret>
  <template slot="button-content">
    <img src="static/img/assets/edit.png">
  </template>
  <b-dropdown-item :to="{ name: 'GroupRegist', params: { item: getItem, id: getKey } }">{{$t('editStr')}}</b-dropdown-item>
  <b-dropdown-item @click.stop="onClickDelete">{{$t('deleteStr')}}</b-dropdown-item>
</b-dropdown>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'GroupDropDown',
  props: {
    tag: String,
    item: Object,
    id: String
  },
  data () {
    return {
      removeTarget: {
        id: '',
        target: ''
      }
    }
  },
  computed: {
    getStatus: function () {
      return this.tag
    },
    getItem: function () {
      return this.item
    },
    getKey: function () {
      return this.id
    }
  },
  methods: {
    ...mapActions({
      removeItem: 'REMOVE_ITEM'
    }),
    ...mapActions('groups/', {
      removeGroup: 'REMOVE_CURRENTGROUP',
      SET_GROUP_INACTIVE: 'SET_GROUP_INACTIVE'
    }),
    onClickDelete: function () {
      this.removeTarget.id = this.id
      this.removeTarget.target = 'groups'
      const $t = this.$t
      this.SET_GROUP_INACTIVE(this.removeTarget)
      this.removeGroup(this.removeTarget)
      this.$swal({
        title: $t('compDeleteStr'),
        type: 'success',
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        padding: '2rem',
        timer: 3000
      })
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/People/GroupDropDown.vue